$(document).ready(function () {
    $("#formContact_modal .button-check-all").on("click", function () {

        $('#formContactAgreeEmail').prop("checked", true);
        $('#formContactAgreePhone').prop("checked", true);
        $('#formContactAgreeRegulations1').prop("checked", true);
        $('#formContactAgreeRegulations2').prop("checked", true);
    });

    function submitContactForm(e, number = '') {
        {
            e.preventDefault();
            if (e.originalEvent.submitter.id === "choose_manual") {
                setInterval(updateDealers, 200);
                $(".inputProvinceWrapper" + number).css('display', 'block');
                $("#choose_manual").remove();
                chooseManuals[number] = true;
                return;
            }
            $('.is-invalid').removeClass('is-invalid');
            $('.invalid-feedback').empty();

            var firstname = $('#formContactFirstname' + number).val();
            var errors = 0;
            $('.form-group--register-firstname').siblings('invalid-feedback').prevObject.empty();
            if (!firstname) {
                $('#formContactFirstname' + number).addClass('is-invalid');
                var errors = 1;
                $('.formContactFirstname' + number).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
            } else {
                if (firstname.length < 3) {
                    $('#formContactFirstname' + number).addClass('is-invalid');
                    var errors = 1;
                    $('.formContactFirstname' + number).siblings('invalid-feedback').prevObject.html('<p>Imię musi zawierać minimum trzy litery.</p>');
                } else {
                    $('#formContactFirstname' + number).removeClass('is-invalid');
                }
            }

            var lastname = $('#formContactLastname' + number).val();
            $('.form-group--register-lastname').siblings('invalid-feedback').prevObject.empty();
            if (!lastname) {
                $('#formContactLastname' + number).addClass('is-invalid');
                var errors = 1;
                $('.formContactLastname' + number).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
            } else {
                if (lastname.length < 3) {
                    $('#formContactLastname' + number).addClass('is-invalid');
                    var errors = 1;
                    $('.formContactLastname' + number).siblings('invalid-feedback').prevObject.html('<p>Nazwisko musi zawierać minimum trzy litery.</p>');
                } else {
                    $('#formContactLastname' + number).removeClass('is-invalid');
                }
            }


            var email = $('#formContactEmail' + number).val();
            if (!email) {
                $('#formContactEmail' + number).addClass('is-invalid');
                $('.formContactEmail' + number).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
                var errors = 1;
            } else {
                if (email) {
                    $('#formContactEmail' + number).removeClass('is-invalid');
                } else {
                    $('#formContactEmail' + number).addClass('is-invalid');
                    $('.formContactEmail' + number).siblings('invalid-feedback').prevObject.html('<p>Wpisz poprawny adres e-mail</p>');
                    var errors = 1;
                }
            }

            var phoneInput = $('#formContactPhone' + number);

            var phone = phoneInput.val();
            if (!phone) {
                $('#formContactPhone' + number).addClass('is-invalid');
                $('.formContactPhone' + number).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
                var errors = 1;
            } else {
                if (phone) {
                    if (phone.length < 7) {
                        $('#formContactPhone' + number).addClass('is-invalid');
                        $('.formContactPhone' + number).siblings('invalid-feedback').prevObject.html('<p>Podany numer telefonu jest za krótki</p>');
                        var errors = 1;
                    } else {
                        if (!validatePhone(phone)) {
                            $('#formContactPhone' + number).addClass('is-invalid');
                            $('.formContactPhone' + number).siblings('invalid-feedback').prevObject.html('<p>Wpisz poprawny 9-cyfrowy numer telefonu</p>');
                            var errors = 1;
                        } else {
                            $('#formContactPhone' + number).removeClass('is-invalid');
                        }
                    }
                }
            }

            var selectedDealer;
            if (number == '3')
                selectedDealer = $("#inputDealerTestDrive").val();
            else
                selectedDealer = $("#inputDealer" + number).val();
            if (selectedDealer === null) {
                $('#inputDealer' + number).addClass('is-invalid');
                $('.inputDealer' + number).html('<p>Proszę wybrać dealera</p>').show();
                var errors = 1;
            } else {
                $('.inputDealer' + number).removeClass('is-invalid');
            }

            var modelId = $("#inputModel" + number).val();
            if (modelId === null) {
                $('#inputModel' + number).addClass('is-invalid');
                $('.inputModel').html('<p>Proszę wybrać model</p>').show();
                var errors = 1;
            } else {
                $('#inputModel' + number).removeClass('is-invalid');
            }


            var dealer = $('#input_dealer').val();
            var message = $('#formContactQuestion' + number).val();
            var agree1 = $('#formContactAgreeEmail' + number).prop('checked');
            var agree2 = $('#formContactAgreePhone' + number).prop('checked');
            var agree3 = $('#formContactAgreeRegulations1' + number).prop('checked');
            var agree4 = $('#formContactAgreeRegulations2' + number).prop('checked');
            var agreeVal1 = 0;
            var agreeVal2 = 0;
            var agreeVal3 = 0;
            var agreeVal4 = 0;
            if (agree1) {
                agreeVal1 = 1;
            }
            if (agree2) {
                agreeVal2 = 1;
            }
            if (agree3) {
                agreeVal3 = 1;
            }
            if (agree4) {
                agreeVal4 = 1;
            }

            /*if (!agree1 && !agree2) {
                var errors = 1;
                $('.form-check-input#formContactAgreeEmail' + number).addClass('is-invalid');
                $('.invalid-feedback-agree-email').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
                $('.form-check-input#formContactAgreePhone' + number).addClass('is-invalid');
                $('.invalid-feedback-agree-phone').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
            }


            if (!email && !phone) {
                var errors = 1;
                $('#formContactEmail' + number).addClass('is-invalid');
                $('.form-group--register-email .invalid-feedback').html('<p>Proszę podać dane na co najmniej jeden kanał komunikacji</p>').show();
                $('#formContactPhone' + number).addClass('is-invalid');
                $('.form-group--register-phone .invalid-feedback').html('<p>Proszę podać dane na co najmniej jeden kanał komunikacji</p>').show();
            }*/

            var emailCheckbox = $('#formContactEmail' + number);
            var agree1 = $('#formContactAgreeEmail' + number);

            if (agree1.is(':checked')) {
                if (emailCheckbox.val() === '') {
                    var errors = 1;
                    $('.invalid-feedback-agree-email').html('<p> Nie podałes E-maila </p>').show();
                }
            }


            var phoneCheckbox = $('#formContactPhone' + number);
            var agree2 = $('#formContactAgreePhone' + number);

            if (agree2.is(':checked')) {
                if (phoneCheckbox.val() === '') {
                    var errors = 1;
                    $('.invalid-feedback-agree-phone').html('<p> Nie podałes numeru telefonu </p>').show();
                }
            }


            var agree3 = $('#formContactAgreeRegulations1' + number).prop('checked');
            /*if (!agree3) {
                $('#formContactAgreeRegulations1' + number).addClass('is-invalid');
                $('.invalid-feedback-agree-regulations1').html('<p>To pole jest wymagane</p>').show();
                var errors = 1;
            } else {
                $('#formContactAgreeRegulations1' + number).removeClass('is-invalid');
                $('.invalid-feedback-agree-regulations1').empty().hide();
                agree3 = 1;
            }*/

            if (!agree1.prop('checked') && !agree2.prop('checked') && !agree3) {
                errors = 1;
                $('#formContactAgreeEmail' + number).addClass('is-invalid');
                $('.formContactAgreeEmail' + number).html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
                $('#formContactAgreePhone' + number).addClass('is-invalid');
                $('.formContactAgreePhone' + number).html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
                $('#formContactAgreeRegulations1' + number).addClass('is-invalid');
                $('.formContactAgreeRegulations1' + number).html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
            }

            var agree4 = $('#formContactAgreeRegulations2' + number).prop('checked');
            if (!agree4) {
                $('#formContactAgreeRegulations2' + number).addClass('is-invalid');
                $('.formContactAgreeRegulations2' + number).html('<p>To pole jest wymagane</p>').show();
                var errors = 1;
            } else {
                $('#formContactAgreeRegulations2' + number).removeClass('is-invalid');
                $('.formContactAgreeRegulations2' + number).empty().hide();
                agree4 = 1;
            }


            console.log(errors);
            if (errors == 0) {
                $('#formContact_modal .btn-form').attr("disabled", "true");

                let formType = window.location.href.includes('kontakt') ? "contact_form" :
                    window.location.href.includes('baic-5-wyprzedaz') ? "wyprzedaz_baic5_form" :
                        window.location.href.includes('baic-7-wyprzedaz') ? "wyprzedaz_baic7_form" :
                        window.location.href.includes('baic-7-wiosna') ? "wiosna_baic7_form" :
                        window.location.href.includes('baic-5-lato') ? "lato_baic5_form" :
                        window.location.href.includes('baic-7-miesiaccudow') ? "miesiaccudow_baic7_form" : "ask_offer";

                let bookType = window.location.href.includes('kontakt') ? "contact_form" : "ask_offer";

                var utm_source = getCookie("utmSource");
                var utm_medium = getCookie("utmMedium");
                var utm_campaign = getCookie("utmCampaign");

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: 'formSubmit',
                    form_id: formType,
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    phone: phone,
                    message: message,
                    comment: message,
                    model_id: modelId??"",
                    branch_id: selectedDealer??"",
                    utm_source: utm_source,
                    utm_medium: utm_medium,
                    utm_campaign: utm_campaign,
                    agree_regulations1: agreeVal1,
                    agree_regulations2: agreeVal2,
                    agree_regulations3: agreeVal3,
                    agree_regulations4: agreeVal4,
                    book_type: bookType
                });

                $.ajax({
                    type: 'POST',
                    url: '/kontakt',
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        firstname: firstname,
                        lastname: lastname,
                        email: email,
                        phone: phone,
                        message: message,
                        comment: message,
                        branch_id: selectedDealer,
                        model_id: modelId,
                        utm_source: utm_source,
                        utm_medium: utm_medium,
                        utm_campaign: utm_campaign,
                        contact_channel_email: (agreeVal1 ? 1 : 0),
                        contact_channel_sms: (agreeVal2 ? 1 : 0),
                        contact_channel_phone: (agreeVal3 ? 1 : 0),
                        i_consent_to_the_processing_of_my_data: (agreeVal4 ? 1 : 0),
                        book_type: bookType,
                        type: bookType
                    },
                    success: function (result) {

                        console.log(result.success);
                        $('#formContact_modal .btn-form').removeAttr("disabled");
                        if (result.success) {


                            $('#formSuccess').modal('show')
                            $("#formContact_modal" + number).trigger("reset");
                            $('#inputDealer' + number).val('');
                            $('#formContactFirstname' + number).val('');
                            $('#formContactLastname' + number).val('');
                            $('#formContactEmail' + number).val('');
                            $('#formContactPhone' + number).val('');
                            $('#formContactQuestion' + number).val('');
                            $('#formContactAgreeEmail' + number).prop('checked', false);
                            $('#formContactAgreePhone' + number).prop('checked', false);
                            $('#formContactAgreeRegulations1' + number).prop('checked', false);
                            $('#formContactAgreeRegulations2' + number).prop('checked', false);

                            $('#contact_modal').modal('hide');

                            // $('#exampleModalCenter2').modal({
                            //     keyboard: false,
                            //     backdrop: 'static',
                            // });
                            // $('#exampleModalCenter2').modal('show')
                            // $("#formContact_main").trigger("reset");

                            if (window.location.href.includes('bmg.sopot')){
                                var axel = Math.random() + "";
                                var a = axel * 10000000000000;
                                $('body').prepend('<iframe src="https://11627135.fls.doubleclick.net/activityi;src=11627135;type=baics0;cat=baic_001;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');
                            }
                        } else {
                            alert('Zapis nie powiódł się. Spróbuj ponownie');
                        }
                    }
                });
            }
        }
    }

    //$("#formContactNew_modal").submit((e) => submitContactForm(e));
    $("#contact_modal").submit((e) => submitContactForm(e));
    $("#formContactNew_modal2").submit((e) => submitContactForm(e, '2'));
    $('#formContactQuestion').on('input', function () {
        currentLength = $(this).val().length;
        const remaining = 300 - currentLength;
        $('#formContactQuestionHelp').text(`Wykorzystano ${currentLength}/300 znaków`);
    });

    let inputsNumbers = 1;
    let provinces = {};
    let intervals = {};
    let chooseManuals = {};
    if ($("#formContactNew_modal").length > 0) {
        provinces[0] = 'Wybierz województwo';
        intervals[0] = setInterval(updateDealers, 1000, 1);
        chooseManuals[0] = false;
    }
    if ($("#formContactNew_modal2").length > 0) {
        provinces[1] = 'Wybierz województwo';
        intervals[1] = setInterval(updateDealers, 1000, 1);
        chooseManuals[1] = false;
    }
    if ($("#testdrive_modal").length > 0) {
        provinces[2] = 'Wybierz województwo';
        intervals[2] = setInterval(updateDealers, 1000, 2);
        chooseManuals[2] = false;
    }

    /**
     number: 0 = kontakt,
     1 = drugi kontakt na stronie modelu,
     2 = jazda testowa
     */
    function updateDealers(number) {
        let id = '';
        if (number === 1)
            id = 2;
        if (number === 2)
            id = 'TestDrive';
        let input = $(`#select2-inputProvince${id}-container`);
        if (input.length > 0) {
            if (false) {
                //if (mobileCheck() && !chooseManual) {
                clearInterval(intervals[number]);
                navigator.geolocation.getCurrentPosition(getLocation, () => null);
            } else {
                if (provinces[number] !== input.attr('title')) {
                    provinces[number] = input.attr('title');
                    $.ajax({
                        _token: $('#token').val(),
                        url: '/filter_dealers',
                        type: 'GET',
                        data: {province: provinces[number]},
                    }).then(function (dealers) {
                        let dealerInput = $("#inputDealer" + id);
                        dealerInput.find('option').remove();
                        dealerInput.append(`<option value="" selected disabled>Wybierz dealera</option>`)
                        for (const dealer of dealers)
                            dealerInput.append(`<option value="${dealer.value}">${dealer.city} ${dealer.name}</option>`);
                    })
                }
            }
        }
    }

    function IsEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function validatePhone(txtPhone) {
        var regex = /^[0-9]+$/
        return regex.test(txtPhone);
    }

    function mobileCheck() {
        let check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v\|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substring(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    function getLocation(position) {
        let location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
        };
        $.ajax({
            _token: $('#token').val(),
            url: '/get_dealers',
            type: 'GET',
        }).then(function (dealers) {
            let nearest = findNearestDealer(location, dealers);
            $(".inputProvinceWrapper").css('display', 'none');
            let dealerInput = $("#inputDealer");
            dealerInput.find('option').remove();
            dealerInput.append(`<option value="${nearest.department_autobahn_company_id}" selected>${nearest.department_city} ${nearest.department_name} (wg lokalizacji)</option>`);
        })
    }

    function findNearestDealer(searchLocation, dealerMarkersArray) {
        if (!searchLocation || !dealerMarkersArray || dealerMarkersArray.length === 0) {
            return null;
        }

        function haversine(lat1, lon1, lat2, lon2) {
            const R = 6371;
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c; //distance
        }

        let nearestDealer = null;
        let minDistance = Number.MAX_VALUE;

        dealerMarkersArray.forEach(dealer => {
            const distance = haversine(
                searchLocation.lat,
                searchLocation.lng,
                dealer.department_latitude,
                dealer.department_longitude
            );
            if (distance < minDistance) {
                minDistance = distance;
                nearestDealer = dealer;
            }
        });
        return nearestDealer;
    }

    function getCookie(cookieName) {
        var name = cookieName + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookieArray = decodedCookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
            var cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    }
});
